<article class="m-message-page"
         :class="{'m--is-state-confirmation': isStateConfirmation,
                  'm--is-state-information': isStateInformation,
                  'm--is-state-warning': isStateWarning,
                  'm--is-state-error': isStateError,
                  'm--is-skin-default': isSkinDefault,
                  'm--is-skin-light': isSkinLight }">
    <header class="m-message-page__header">
        <h2 class="m-message-page__title"
            v-if="title"
            v-html="title"></h2>
        <div class="m-message-page__icon-container"
             aria-hidden="true">
            <m-svg class="m-message-page__icon"
                   :width="propImageSize"
                   :height="propImageSize"
                   :name="svgName || iconNameProp" />
        </div>
    </header>
    <div class="m-message-page__body"
         v-if="hasBody">
        <p class="m-message-page__hints"
           :class="{'m--no-content': !hasLinksAndSlot}"
           v-if="hasHints"
           v-for="hint in hints"
           ref="hint">{{hint}}</p>
        <div class="m-message-page__details"
             v-if="$slots.default">
            <slot />
        </div>
        <ul class="m-message-page__links"
            v-if="hasLinks">
            <li ref="link"
                v-for="link in links">
                <m-link class="m-message-page__link"
                        bullet-point="true"
                        mode="link"
                        :url="link.url"
                        :target="isTargetExternal(link.external)">{{link.label}}</m-link>
            </li>
        </ul>
    </div>
</article>
